import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';


export interface CartItem {
  id: string;
  name: string;
  price: number;
  discount?: number;
  quantity: number;
  imageUrl?: string;
  icon: string;
}

@Component({
  selector: 'app-shopping-cart',
  standalone: true, // ✅ MUST be true
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule
  ],
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss'],
})
export class ShoppingCartComponent {

cartItems: CartItem[] = [];

  constructor(
    public dialogRef: MatDialogRef<ShoppingCartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { items: CartItem[] }
  ) {
    this.cartItems = data.items || [];
  }

  getDiscountedPrice(item: CartItem): number {
    if (item.discount) {
      return item.price * (1 - item.discount / 100);
    }
    return item.price;
  }

  getItemTotal(item: CartItem): number {
    return this.getDiscountedPrice(item) * item.quantity;
  }

  getCartSubtotal(): number {
    return this.cartItems.reduce((total, item) => total + this.getItemTotal(item), 0);
  }

  getTax(): number {
    return this.getCartSubtotal() * 0.18; // 18% VAT
  }

  getCartTotal(): number {
    return this.getCartSubtotal() + this.getTax();
  }

  updateQuantity(item: CartItem, change: number): void {
    item.quantity = Math.max(1, item.quantity + change);
  }

  removeItem(itemId: string): void {
    this.cartItems = this.cartItems.filter(item => item.id !== itemId);
    this.data.items = this.cartItems;
  }

  close(): void {
    this.dialogRef.close();
  }

  proceedToCheckout(): void {
    this.dialogRef.close({ action: 'checkout', items: this.cartItems });
  }
}
